<script setup lang="ts">
/**
 * The artifacts mark.
 *
 * It is a single filled path, unlike the outline glyphs the rest of the console
 * uses, so it carries its own `viewBox` (640×640, the source's grid) and is
 * styled with `fill="currentColor"` — colour and size both come from the caller's
 * classes, exactly as the stroke icons do via `stroke="currentColor"`.
 *
 * Shared by the sidebar item and the Analytics tile so the two cannot drift.
 */
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M344.5 61.6C329.6 53 311.4 53 296.5 61.6L208.2 112.5C193.3 121.1 184.2 136.9 184.2 154.1L184.2 265.2L88 320.8C73.1 329.4 64 345.2 64 362.3L64 464.2C64 481.3 73.1 497.2 88 505.8L176.2 556.7C191.1 565.3 209.3 565.3 224.2 556.7L320.4 501.1L416.6 556.7C431.5 565.3 449.7 565.3 464.6 556.7L553 505.8C567.9 497.2 577 481.4 577 464.2L577 362.3C577 345.2 567.9 329.3 553 320.7L456.8 265.1L456.8 154C456.8 136.9 447.7 121 432.8 112.4L344.5 61.6zM112 343.9L200.2 293L288.4 343.9L200.2 394.8L112 343.9zM96 371.6L184.2 422.5L184.2 524.4L104 478.1C99 475.2 96 470 96 464.2L96 371.5zM216.2 524.4L216.2 422.5L304.4 371.6L304.4 473.5L216.2 524.4zM336.5 371.6L424.7 422.5L424.7 524.4L336.5 473.5L336.5 371.6zM456.7 524.4L456.7 422.5L544.9 371.6L544.9 464.3C544.9 470 541.9 475.3 536.9 478.2L456.7 524.5zM529 343.9L440.8 394.8L352.6 343.9L440.8 293L529 343.9zM336.5 316.2L336.5 214.3L424.7 163.4L424.7 265.3L336.5 316.2zM408.7 135.6L320.5 186.5L232.3 135.6L312.5 89.3C317.5 86.4 323.5 86.4 328.5 89.3L408.7 135.6zM216.2 163.3L304.4 214.2L304.4 316.1L216.2 265.2L216.2 163.3z"
    />
  </svg>
</template>
